import { toast } from "materia"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useChatRuntime, useChatState } from "../../hooks/useChat"
import type { ChatRefusal } from "../../types"

const LINES: Record<ChatRefusal["kind"], string> = {
  send: "chat.REFUSAL_SEND",
  "archived-group": "chat.REFUSAL_ARCHIVED_GROUP",
  "not-member": "chat.REFUSAL_NOT_MEMBER_SEND",
  "retract-expired": "chat.REFUSAL_RETRACT_EXPIRED",
  retract: "chat.REFUSAL_RETRACT",
  "edit-expired": "chat.REFUSAL_EDIT_EXPIRED",
  edit: "chat.REFUSAL_EDIT",
}

/**
 * Says what the server refused, once, and clears it. Renders nothing, and
 * sits above the screens rather than inside the chat view: a bounce can land
 * after the reader has moved on, and it is still their message that failed.
 */
export function RefusalToast() {
  const { t } = useTranslation()
  const refusal = useChatState((state) => state.refusal)
  // Actions rather than `useChat`, which would subscribe this to the whole
  // conversation list to fetch one stable function.
  const { clearRefusal } = useChatRuntime().actions

  useEffect(() => {
    if (!refusal) return

    toast(t(LINES[refusal.kind]))
    clearRefusal()
  }, [refusal, clearRefusal, t])

  return null
}
